import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

export const mailGroupList = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_MAIL_GROUP_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_MAIL_GROUP_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_MAIL_GROUP_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_USER_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
  })(state, action);
};
